<template>
	<div class="yiContainer">
		<div class="section">
			<!-- 导航 -->
			<div class="navBar">
				<img class="navLogo" src="../assets/logo2.png" alt="" @click="enterHome()" />
				<ul class="navBarItem">
					<!-- <li class="busiz-active-sel">
						<router-link exact to="/" tag="a">首页</router-link>
					</li> -->
					<li>
						<router-link to="/aboutlanshu" exact tag="a">关于兰树</router-link>
					</li>
					<el-dropdown>
						<li class="brandLi">
							<router-link exact to="/huaiBrand" style="font-size: 1em" tag="a">兰树品牌</router-link>
						</li>
						<el-dropdown-menu class="elDropdown" exact slot="dropdown"
							style="background: rgb(236, 245, 255) !important">
							<el-dropdown-item>
								<li>
									<router-link :class="brandActive == '1' ? 'elDropdown_active' : ''"
										style="background: rgb(236, 245, 255) !important; color: #000 !important; "
										to="/huaiBrand" tag="a">
										淮树</router-link>
								</li>
							</el-dropdown-item>
							<el-dropdown-item>
								<li>
									<router-link :class="brandActive == '2' ? 'elDropdown_active' : ''"
										style="background: rgb(236, 245, 255) !important; color: #000 !important; "
										to="/brand" tag="a">心清堂
									</router-link>
								</li>
							</el-dropdown-item>
							<el-dropdown-item>
								<li>
									<router-link :class="brandActive == '3' ? 'elDropdown_active' : ''"
										style="background: rgb(236, 245, 255) !important; color: #000 !important; "
										to="/shuiBrand" tag="a">
										水姻缘</router-link>
								</li>
							</el-dropdown-item>
							<el-dropdown-item>
								<li>
									<router-link :class="brandActive == '4' ? 'elDropdown_active' : ''"
										style=" background: rgb(236, 245, 255) !important; color: #000 !important;"
										to="/yiBrand" tag="a">
										一清堂</router-link>
								</li>
							</el-dropdown-item>
							<el-dropdown-item>
								<li>
									<router-link :class="brandActive == '5' ? 'elDropdown_active' : ''"
										style=" background: rgb(236, 245, 255) !important; color: #000 !important;"
										to="/zhongBrand" tag="a">
										<span>Dr.CHUNG<span style="vertical-align: super;">+</span></span></router-link>
								</li>
							</el-dropdown-item>
							<el-dropdown-item>
								<li>
									<router-link :class="brandActive == '6' ? 'elDropdown_active' : ''"
										style=" background: rgb(236, 245, 255) !important; color: #000 !important;"
										to="/lanshuBrand" tag="a">兰树</router-link>
								</li>
							</el-dropdown-item>
							<el-dropdown-item>
								<li>
									<router-link :class="brandActive == '7' ? 'elDropdown_active' : ''"
										style=" background: rgb(236, 245, 255) !important; color: #000 !important;"
										to="/zbqfBrand" tag="a">植本清方</router-link>
								</li>
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
					<li><router-link to="/park" exact tag="a">智慧园区</router-link></li>
					<li>
						<router-link to="/brandLanshu" exact tag="a">美业菩提</router-link>
					</li>
					<li><router-link to="/school" exact tag="a">兰树商学院</router-link></li>

					<li>
						<router-link to="/dynamicLanshu" exact tag="a">菩提基金会</router-link>
					</li>

					<li>
						<router-link to="/lanshuTrends" exact tag="a">兰树动态</router-link>
					</li>
				</ul>
			</div>

			<div class="topImg">
				<img src="https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2023-08-18_14-17-32_96170.png"
					alt="">
			</div>
		</div>


		<div style="background:#fff;">
			<!-- 产品 故事 护肤 -->
			<div class="product">
				<div class="top_text">
					<el-dropdown>
						<span class="text_product">产品</span>
						<el-dropdown-menu slot="dropdown">

							<el-dropdown-item>
								<router-link to="/yiYellow" style="text-decoration: none;color: #000;">倾城秘颜眼部系列
								</router-link>
							</el-dropdown-item>
							<el-dropdown-item>
								<router-link to="/yiPurple" style="text-decoration: none;color: #000;">嫱颜玉润精粹系列
								</router-link>
							</el-dropdown-item>
							<el-dropdown-item>
								<router-link to="/yiWhite"
									style="text-decoration: none;color: #000;">美蝉光感蕴能系列</router-link>
							</el-dropdown-item>
							<el-dropdown-item>
								<router-link to="/yiRed"
									style="text-decoration: none;color: #000;">玉奴清滢平衡系列</router-link>
							</el-dropdown-item>
							<el-dropdown-item>
								<router-link to="/yiBlack"
									style="text-decoration: none;color: #000;">丽姬凝润冰肌系列</router-link>
							</el-dropdown-item>
							<el-dropdown-item>
								<router-link to="/yiNew"
									style="text-decoration: none;color: #000;">一清堂特品系列</router-link>
							</el-dropdown-item>
							<el-dropdown-item>
								<router-link :to="{ path: '/productsList', query: { brandId: 3 } }"
									style="text-decoration: none;color: #000;">一清堂套盒系列</router-link>
							</el-dropdown-item>
              <el-dropdown-item>
                <router-link to="/yiClean" style="text-decoration: none;color: #000;">洁修养系列
                </router-link>
              </el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
					<span class="text_story">
						<router-link to="/yiStory" style="text-decoration: none;color: #000;">故事</router-link>
					</span>
					<span class="text_skin">
						<router-link to="/yiSkin" style="text-decoration: none;color: #000;">护肤</router-link>
					</span>
					<span class="text_design">
						<router-link to="/yiDesign" style="text-decoration: none;color: #000;">设计</router-link>
					</span>
				</div>
			</div>


			<!-- 品牌文化 -->
			<div class="customer">
				<img src="https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2023-08-18_14-11-20_86414.png"
					alt="">
			</div>
			<!-- <div class="customer con">
			<div class="content">
				<div class="top">
					<img src="../assets/yiBrand/design/custom-title.png" alt="">
				</div>
				<div class="detail">
					<img src="../assets/yiBrand/design/detail-title.png" alt="">

				</div>
			</div>
			<div class="EN_content">
				<div class="title">BRAND ORIGIN</div>
				<div class="detail">
					The design of “堂” uses jade seal cutting as the prototype. Upright straight lines and square curves
					are combined to form the shape of a window typical of the East. The upright lines, which stand for
					rules and laws, symbolize the brand’s adherence to the belief that “Nobody witnesses what you have
					done, yet heaven knows what goes in your mind.” The four angels formed by curves indicate female
					strength free from any restrictions. The overall design interprets the brand’s foothold in oriental
					wisdom and the cultural connotation of oriental aesthetics.

				</div>
			</div>
		</div>

		<div style="margin-top:200px;height:185px;background:linear-gradient(to bottom, #9964DA, #ECEAF2, #FCFCFD);"></div> -->

			<!-- 色卡 -->
			<div class="allColor">
				<div class="color">
					<div class="top">
						<div class="top-left">
							<div class="box">
								<img src="../assets/yiBrand/design/top-left.png" alt="">
							</div>
						</div>
						<div class="top-right">
							<div class="box">
								<img src="../assets/yiBrand/design/top-right.png" alt="">
							</div>
						</div>
					</div>
					<div class="center">
						<div class="center-left">
							<div class="title">PANTONE 2725C</div>
							<div class="color-title">#655DC6</div>
						</div>
						<div class="center-c">
							<div class="title">PANTONE 201C</div>
							<div class="color-title">#A32035</div>
						</div>
						<div class="center-right">
							<div class="title">BLACK</div>
							<!-- <div class="color-title">#655DC6</div> -->
						</div>
					</div>
					<div class="bottom">
						<div class="title">WHITE</div>
					</div>
				</div>
			</div>


			<!-- 关于颜色 -->
			<div class="about-color">
				<div class="left">
					BRAND
				</div>
				<div class="center">
					<div class="cleft">关于颜色</div>
					<div class="cright">ABOUT COLOR</div>
				</div>
				<div class="right">
					在品牌色彩上，我们始终坚持带给用户最尊贵的体验。因此我们选取了玄青和乌金两色做为品牌主色。<br />
					<br />
					主色玄青，为贵族专用配色，象征一清堂品牌对东方智慧的传承，融汇与共生象征品牌用户的高端尊享之姿。<br />
					主色乌金在汉文化中为皇家御用色，尊贵高奢的同时隐喻循环不息的平衡之道。<br />
					<br />
					彰显一清堂为用户带来尊享养肤奢品的初心。
				</div>
			</div>

			<div class="centerImg">
				<img src="https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2023-08-18_14-16-53_86076.png"
					alt="">
			</div>



			<!-- 部分VI展示 -->

			<div class="VIshow">
				<div class="title">
					部分VI展示
				</div>
				<div class="Badge">
					<div class="left">
						<img src="../assets/yiBrand/design/Badge.png" alt="">
					</div>
					<div class="right">
						<div class="CN">徽章</div>
						<div class="EN">Badge</div>
					</div>
				</div>
				<div class="Letter">
					<div class="left">
						<div class="CN">信封</div>
						<div class="EN">Letter</div>
					</div>
					<div class="right">
						<img src="../assets/yiBrand/design/Letter.png" alt="">
					</div>
				</div>
				<div class="Pillow">
					<div class="left">
						<img src="../assets/yiBrand/design/Pillow.png" alt="">
					</div>
					<div class="right">
						<div class="CN">抱枕</div>
						<div class="EN">Pillow</div>
					</div>
				</div>
				<div class="Folder">
					<div class="left">
						<div class="CN">文件夹</div>
						<div class="EN">Folder</div>
					</div>
					<div class="right">
						<img src="../assets/yiBrand/design/Folder.png" alt="">
					</div>
				</div>
			</div>


			<!-- 关于VI系统 -->
			<div class="VISystem">
				<div class="content con">
					<div class="detail">
						<div class="CN">
							VI系统概述：企业拥有一套完整的VI系统，<br />
							均使用所设定的标准字体和配色，<br />
							以树立统一、独特、鲜明的企业视觉形象。
						</div>
						<div class="EN">
							System overview: <br />
							The company has an integral VI system, <br />
							using the given standard font and colors<br />
							to build a united,<br />
							unique and strong brand visual image.
						</div>
					</div>
					<div class="center">
						<div class="cleft">关于VI系统</div>
						<div class="cright">ABOUT VI</div>
					</div>
					<div class="right">
						BRAND
					</div>
				</div>
			</div>

			<!-- <div style="height:185px;background:linear-gradient(to top, #9964DA, #ECEAF2, #FCFCFD);"></div> -->

			<div class="bottomImg">
				<img src="https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2023-08-18_14-16-22_10429.png"
					alt="">
			</div>


			<!-- 关于空间 -->
			<div class="aboutSI">
				<div class="top">
					<div class="left">关于空间</div>
					<div class="right">ABOUT SI</div>
				</div>
				<div class="center">
					一清堂空间将品牌气质与终端视觉完美融合，颜色上以品牌主色玄青搭配东方之即白，象征一清堂品牌对东方智慧的传承、融汇与共生。彰显一清堂品牌用户高端尊享之姿。大量点缀御用乌金，隐喻循环不息的平衡之道与太阳初升的活力光辉。本配色为彰显一清堂品牌为用户带来尊享养肤奢品的初心。
				</div>
				<div class="bottom">
					The space of YQT combines brand temperament with terminal vision perfectly. In color, YQT uses its
					main
					color -deep black and the first white flight of morning in the east, which symbolizes its
					inheritance,
					combination and symbiosis for oriental wisdom and indicates the nobleness of its users. Besides, it
					is
					largely interspersed with imperial golden black, which symbolizes cyclic balance and lively radiance
					of
					the rising sun. The color blending manifests the original intention of YQT- offering users a luxury
					product of skincare.
				</div>
			</div>



			<!-- 系列推荐 -->
			<div class="recommend">
				<div class="title-wrap">
					<div class="name">系列推荐</div>
					<div class="en">PRODUCT SERIESv</div>
					<div class="line"></div>

				</div>
				<div class="content con">
					<!-- 轮播图 -->
					<div class="prev">
						<img src="../assets/yiBrand/prev.png" @click="arrowClick('prev')" />
					</div>
					<div class="carousel">
						<el-carousel arrow="never" height="510px" :autoplay="true" indicator-position="none"
							ref="cardShow">
							<el-carousel-item v-for="(item, index) in datalist" :key="index">
								<div class="box">
									<div class="left">
										<div class="cover" @click="goPage(item.color1)">
											<img :src="item.img1" alt="">
										</div>
										<div class="name">{{ item.name1 }}</div>
										<div class="more">
											<span @click="goPage(item.color1)">查看更多</span>
										</div>
									</div>
									<div class="right">
										<div class="cover" @click="goPage(item.color2)">
											<img :src="item.img2" alt="">
										</div>
										<div class="name">{{ item.name2 }}</div>
										<div class="more">
											<span @click="goPage(item.color2)">查看更多</span>
										</div>
									</div>
								</div>
							</el-carousel-item>
						</el-carousel>
					</div>
					<div class="next">
						<img src="../assets/yiBrand/next.png" @click="arrowClick('next')" />
					</div>

				</div>
			</div>




			<div class="section pageBox6">
				<div class="pageBoxOut2">
					<!-- 底部 -->
					<div class="footerBox">
						<div class="footerBoxHeader">
							<div class="footerBoxHeaderLeft">
								<img class="codeImg" src="../assets/code.png" alt="" />
								<span class="codeText">兰树公众号</span>
							</div>
							<div class="footerBoxHeaderCenter">
								<img class="codeImg" src="../assets/xcxNew.jpg" alt="" />
								<span class="codeText">兰树云小程序</span>
							</div>
							<div class="footerBoxHeaderRight">
								<img class="codeImg" src="../assets/yiBrand/yiqingtang.png" alt="">
								<span class="codeText">官方微信公众号</span>
							</div>
						</div>
						<div class="footerMainBox">
							<li class="footerShop"><a target="_blank"
									href="https://huaishu.tmall.com/shop/view_shop.htm?spm=a230r.7195193.1997079397.2.124378dduXIhiW">淮树旗舰店</a>
							</li>
							<li class="footerShop"><a target="_blank"
									href="https://shop537937985.taobao.com/?spm=a230r.7195193.1997079397.2.374448f3jcdl9s">心清堂官方企业店</a>
							</li>
							<li class="footerShop"><a target="_blank" href="https://shop349169226.taobao.com/?spm=a21xtw.29978516.0.0">水姻缘旗舰店</a>
							</li>
							<li class="footerShop"><a target="_blank"
									href="https://shop537937985.taobao.com/?spm=a230r.7195193.1997079397.2.374448f3jcdl9s">一清堂官方企业店</a>
							</li>
							<li class="footerShop"><a target="_blank" href="https://drchung.tmall.com">Dr.CHUNG<span></span>旗舰店</a></li>
							<li class="footerShop"><a target="_blank" href="https://zhibenqingfang.tmall.com">植本清方旗舰店</a></li>
							<div class="lastHeader">
								<li><router-link to="/login" tag="a">登录</router-link></li>
								|
								<li><router-link to="/login" tag="a">注册</router-link></li>
							</div>
						</div>

						<div class="footerInfoBox">
							<div class="emailBox">邮箱: postermaster@lasur.com</div>
							<div class="phoneBox">电话: 0571-89025888</div>
							<div class="addressBox">
								地址: 浙江省杭州市之江东路越秀·维多利中心A座 17楼
							</div>
						</div>

						<div class="footerLine"></div>
						<div class="footerBoxBottom">
							<div class="footerLeft">
								Copyright © 2023 兰树化妆品股份有限公司
								<a target="_blank"
									href="https://beian.miit.gov.cn/#/Integrated/index">浙ICP备20018890号-1</a>
							</div>
						</div>
					</div>

				</div>

			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			drawer: false,
			datalist: [{
				img1: require("../assets/yiBrand/site-1.png"),
				name1: "倾城秘颜眼部系列",
				color1: "yellow",
				img2: require("../assets/yiBrand/site-2.png"),
				name2: "嫱颜玉润精粹系列",
				color2: "purple"
			},
			{
				img1: require("../assets/yiBrand/site-3.png"),
				name1: "美蝉光感蕴能系列",
				color1: "white",
				img2: require("../assets/yiBrand/site-4.png"),
				name2: "玉奴清滢平衡系列",
				color2: "red"
			},
			{
				img1: require("../assets/yiBrand/site-5.png"),
				name1: "丽姬凝润冰肌系列",
				color1: "black",
				img2: require("../assets/yiBrand/site-6.png"),
				name2: "一清堂套盒系列",
				color2: "old"
			},
			{
				img1: require("../assets/yiBrand/site-7.png"),
				name1: "一清堂特品系列",
				color1: "new",
				img2: require("../assets/yiBrand/site-8.png"),
				name2: "洁修养系列",
				color2: "clean"
			}

			],
			brandActive: 1,
		};
	},
	methods: {
		enterProducts(id) {
			this.$router.push({ path: "/productsList", query: { brandId: id } });
		},
		enterHome() {
			this.$router.push({ path: "/" });
		},
		arrowClick(val) {
			if (val === 'next') {
				this.$refs.cardShow.next()
			} else {
				this.$refs.cardShow.prev()
			}
		},
		goPage(val) {
			switch (val) {
				case 'clean':
          this.$router.push({
            path: "/yiClean"
          })
          break;
        case 'red':
					this.$router.push({
						path: "/yiRed"
					})
					break;
				case 'purple':
					this.$router.push({
						path: "/yiPurple",
					})
					break;
				case 'black':
					this.$router.push({
						path: "/yiBlack",
					})
					break;
				case 'yellow':
					this.$router.push({
						path: "/yiYellow",
					})
					break;
				case 'white':
					this.$router.push({
						path: "/yiWhite",
					})
					break;
				case 'old':
					this.$router.push({
						path: '/productsList', query: { brandId: 3 }
					})
					break;
				case 'new':
					this.$router.push({
						path: '/yiNew',
					})
					break;
			}

		}
	},
};
</script>

<style scoped>
.yiContainer {
	width: 100%;
	overflow: hidden;
	margin: 0;
	padding: 0;
	position: relative;
}


/* 导航 */

/* 下拉菜单栏 选中 */
.navBar {
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	position: absolute;
	justify-content: space-between;
	top: 0;
	background: #ffffff;
	z-index: 999;
}

.navLogo {
	width: 10%;
	margin-left: 5em;
	cursor: pointer;
}

.navBarItem {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: flex-end;
}

.navBarItem li {
	/* list-style: none;
          padding: 1.5em 2.5em 1.5em 2.5em;
          float: left; */
	list-style: none;
	/* padding: 25px 40px 25px 40px; */
	float: left;
	/* margin-left: 2em; */
}

.brandLi a {
	text-decoration: none;
	font-size: 0.875em;
	font-family: PingFangSC-Semibold, PingFang SC;
	font-weight: 600;
	color: #222222;
	line-height: 20px;
	padding-top: 1.6em !important;
	padding-bottom: 1.6em !important;
	padding-left: 2em;
	padding-right: 2em;
}

.navBarItem li a {
	text-decoration: none;
	font-size: 0.875em;
	font-family: PingFangSC-Semibold, PingFang SC;
	font-weight: 600;
	color: #222222;
	line-height: 20px;
	padding-top: 1.4em;
	padding-bottom: 1.4em;
	padding-left: 1.4rem;
	padding-right: 1.4rem;
}


.elDropdown a {
	color: #111111;
	text-decoration: none;
}



.pageBoxOut2 {
	width: 90%;
	height: 100%;
	justify-content: center;
	display: flex;
	flex-direction: column;
	align-items: center;
	margin: 0 auto;
	box-sizing: border-box;
}



/* pageBox6 */
.pageBox6 {
	margin-top: -150px;
	width: 100%;
	height: 653px;
	display: flex;
	flex-direction: column;
	color: #000;
	/* background: #000; */
	/* background-image: url(../assets/yiBrand/bg2.png); */
	/* background:linear-gradient(to top, #9D92BF, #ECEAF2, #FCFCFD,#fff); */
}

/* footer */
.footerBox {
	width: 90%;
	/* height: 287px; */
	/* position:absolute;
             bottom:0; */
	margin: 0 auto;
	flex-direction: column;
	z-index: 999;
}

.footerBoxHeader {
	margin: 0 auto;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	margin-top: 2%;
}

.footerBoxHeaderLeft {
	display: flex;
	flex-direction: column;
	align-items: center;
}

.footerBoxHeaderCenter {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-left: 5em;
}

.footerBoxHeaderCenter {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-left: 5em;
}

.footerBoxHeaderRight {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-left: 5em;
}

.codeImg {
	width: 90px;
}

.codeText {
	font-size: 0.88em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 200;
	color: #000;
	line-height: 20px;
	margin-top: 0.5rem;
}

.footerLine {
	width: 79%;
	height: 1px;
	display: flex;
	background: #000;
	opacity: 0.1;
	margin: 0 auto;
	align-items: center;
	margin-top: 1em;
}

.footerInfoBox {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 2rem;
}

.emailBox {
	font-size: 0.875rem;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 200;
	color: #000;
	line-height: 20px;
}

.phoneBox {
	font-size: 0.875rem;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 200;
	color: #000;
	line-height: 20px;
	margin-top: 0.5rem;
}

.addressBox {
	font-size: 0.875rem;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 200;
	color: #000;
	line-height: 20px;
	margin-top: 0.5rem;
}

.footerBoxBottom {
	display: flex;
	margin: 0 auto;
	align-items: center;
	flex-direction: row;
	justify-content: center;
	margin-top: 1rem;
}

.footerLeft {
	font-size: 0.875em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 200;
	color: #000;
	line-height: 24px;
}

.footerLeft a {
	text-decoration: none;
	cursor: pointer;
	color: #000;
}

.footerLeft a:hover {
	color: #000;
}

.lastHeader {
	display: flex;
	flex-direction: row;
	font-size: 0.875em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 200;
	color: #000;
	line-height: 28px;
	margin-left: 2em;
}

.lastHeader li a {
	text-decoration: none;
	font-size: 0.875rm;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 200;
	color: #000;
	line-height: 28px;
}

.lastHeader li {
	list-style: none;
}

.footerMainBox {
	display: flex;
	flex-direction: row;
	margin: 0 auto;
	align-items: center;
	flex-direction: row;
	justify-content: center;
	margin-top: 2em;
}

.footerShop {
	list-style: none;
	position: relative;
}

.footerShop span{
	margin-right: 10px;
}
.footerShop span::after{
	content: '+';
	display:block;
	position: absolute;
	top: -6px;
	right: 43px;
}

.footerShop a {
	text-decoration: none;
	font-size: 0.875rem;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 200;
	color: #000;
	padding-left: 2em;
	line-height: 28px;
	cursor: pointer;
}



/* 首图 */
.topImg {
	/* margin-top: 66px; */
	width: 100%;
	position: fixed;
	background-color: #fff;
	z-index: -1;
	max-height: 462px;
	transition-property: all;
	text-align: center;
}

.topImg img {
	width: 1920px;
	/* height: 462px; */
}


/* 产品 故事 护肤 */
.product {
	margin-top: 830px;
	box-shadow: 0px -20px 50px white;
}

.product .top_text {
	text-align: center;
	/* margin-bottom: 53px; */
}

.product .top_text span {
	font-size: 16px;
	font-family: PingFnagLight;
	font-weight: 100;
	color: #000000;
	letter-spacing: 1px;
}

.product .top_text .text_product {
	margin-right: 40px;
	cursor: pointer;
}

.product .top_text .text_story {
	margin-right: 40px;
	cursor: pointer;
}

.product .top_text .text_skin {
	cursor: pointer;
}


.product .top_text .text_design {
	margin-left: 40px;
	cursor: pointer;
	padding-bottom: 5px;
	border-bottom: 1px solid #979797;
}


/* 品牌文化 */
.customer {
	margin-top: 6px;
	width: 100%;
	position: relative;
	text-align: center;
}

.customer img {
	/* width: 1920px; */
	height: 900px;
}

.customer .content {
	display: flex;
	flex-direction: row;
	/* background-color: #3F3A60; */
	/* justify-content: space-between; */
	/* background-color: #3F3A60; */
}

.customer .content .top {
	/* margin-top: 100px; */
	position: relative;
	left: 90px;
	top: 120px;
}

.customer .content .top img {
	width: 71px;
	height: 362px;
}

.customer .content .detail {
	margin-top: 236px;
	margin-left: 516px;
}

.customer .content .detail img {
	width: 685px;
	height: 221px;
}

.customer .EN_content {
	width: 1100px;
	margin: 0 auto;
	margin-top: 191px;
}

.customer .EN_content .title {
	height: 35px;
	font-size: 21px;
	font-family: PingFangRegular;
	font-weight: 300;
	color: #A48D29;
	line-height: 35px;
}

.customer .EN_content .detail {
	width: 1198px;
	height: 125px;
	margin-top: 26px;
	font-size: 18px;
	font-family: PingFangSC-Light, PingFang SC;
	font-weight: 100;
	color: #A48D29;
	line-height: 25px;
	word-break: break-all;
}



/* 色卡 */
.allColor {
	/* padding-bottom: 0px; */
	/* margin-top: -20px; */
	height: 940px;
	background: linear-gradient(180deg, #F2DEC0 0%, #ECEAF2 28%, #FCFCFD 100%);
}

.allColor .color {
	width: 1300px;
	margin: 0 auto;
	height: 1017px;
	padding-top: 138px;
	/* margin-top: 138px; */
}

.allColor .color .top {
	display: flex;
}

.allColor .color .top .top-left {
	width: 650px;
	height: 597px;
	background: #3C3A5D;
}

.allColor .color .top .top-left .box {
	margin-top: 48px;
	margin-left: 55px;
}

.allColor .color .top .top-right {
	width: 650px;
	height: 597px;
	background: #9E882D;
}

.allColor .color .top .top-right .box {
	margin-top: 48px;
	margin-left: 55px;
}

.allColor .color .center {
	display: flex;
	color: #FEFEFE;
}

.allColor .color .center .title {
	margin-top: 50px;
	margin-left: 50px;
	font-size: 18px;
}

.allColor .color .center .color-title {
	margin-top: 8px;
	margin-left: 50px;
	font-size: 12px;
}

.allColor .color .center .center-left {
	width: 434px;
	height: 210px;
	background: #655DC6;
}

.allColor .color .center .center-c {
	width: 434px;
	height: 210px;
	background: #A32035;
}

.allColor .color .center .center-right {
	width: 434px;
	height: 210px;
	background: #000;
}

.allColor .color .bottom {
	width: 1298px;
	height: 210px;
	background: #fff;
	border: 1px solid #9E882D;
}

.allColor .color .bottom .title {
	margin-top: 50px;
	margin-left: 29px;
	color: #040201;
	font-size: 18px;
	font-weight: 800;
}


/* 关于颜色 */
.about-color {
	display: flex;
	justify-content: center;
	margin-top: 262px;
	/* margin-bottom: 128px; */
	/* background-color: yellow; */
}

.about-color .left {
	margin-left: 29px;
	margin-top: 93px;
	width: 88px;
	height: 33px;
	font-size: 24px;
	font-family: PingFangSC-Light, PingFang SC;
	font-weight: 300;
	color: #333;
	line-height: 33px;
}

.about-color .center {
	margin-top: 104px;
	margin-left: 121px;
	writing-mode: vertical-lr;
}

.about-color .center .cleft {
	width: 22px;
	height: 128px;
	font-size: 30px;
	font-family: PingFangSC-Light, PingFang SC;
	font-weight: 300;
	color: #333;
	line-height: 32px;
	letter-spacing: 1px;
}

.about-color .center .cright {
	margin-left: 14px;
	width: 30px;
	height: 173px;
	font-size: 22px;
	font-family: PingFangSC-Thin, PingFang SC;
	font-weight: 100;
	color: #333;
	line-height: 30px;
	letter-spacing: 1px;
}

.about-color .right {
	margin-top: 128px;
	margin-left: 307px;
	width: 688px;
	height: 200px;
	font-size: 18px;
	font-family: PingFangSC-Thin, PingFang SC;
	font-weight: 100;
	color: #333;
	line-height: 25px;
}

.centerImg {
	width: 1300px;
	margin: 0 auto;
	margin-top: 128px;
}

.centerImg img {
	width: 1299px;
	height: 432px;

}


/* 部分VI展示 */
.VIshow {
	width: 1200px;
	margin: 0 auto;
	margin-top: 116px;
}

.VIshow .title {
	height: 48px;
	font-size: 34px;
	font-family: PingFangSC-Light, PingFang SC;
	font-weight: 300;
	color: #333333;
	line-height: 48px;
}

.VIshow .Badge {
	display: flex;
	margin-top: 37px;
}

.VIshow .left {
	width: 600px;
	height: 324px;
	overflow: hidden;
}

.VIshow .right img,
.VIshow .left img {
	width: 100%;
	height: 100%;
	object-fit: cover;
	transition: 0.2s
}

.VIshow .right img:hover,
.VIshow .left img:hover {
	transform: scale(1.1);
}

.VIshow .right {
	width: 600px;
	height: 324px;
	overflow: hidden;
}

.VIshow .Letter,
.VIshow .Pillow,
.VIshow .Folder {
	display: flex;
}

.VIshow .Badge .CN {
	margin-left: 67px;
	/* width: 68px; */
	height: 48px;
	font-size: 34px;
	font-family: PingFangSC-Light, PingFang SC;
	font-weight: 300;
	color: #444444;
	line-height: 48px;
}

.VIshow .Badge .EN {
	margin-left: 74px;
	/* width: 73px; */
	height: 33px;
	font-size: 24px;
	font-family: PingFangSC-Thin, PingFang SC;
	font-weight: 100;
	color: #444444;
	line-height: 33px;
}

.VIshow .Letter .CN {
	margin-top: 213px;
	margin-left: 1px;
	/* width: 68px; */
	height: 48px;
	font-size: 34px;
	font-family: PingFangSC-Light, PingFang SC;
	font-weight: 300;
	color: #444444;
	line-height: 48px;
}

.VIshow .Letter .EN {
	margin-left: 1px;
	/* width: 72px; */
	height: 33px;
	font-size: 24px;
	font-family: PingFangSC-Thin, PingFang SC;
	font-weight: 100;
	color: #444444;
	line-height: 33px;
}

.VIshow .Pillow .CN {
	margin-top: 216px;
	margin-left: 74px;
	/* width: 68px; */
	height: 48px;
	font-size: 34px;
	font-family: PingFangSC-Light, PingFang SC;
	font-weight: 300;
	color: #444444;
	line-height: 48px;
}

.VIshow .Pillow .EN {
	margin-left: 76px;
	/* width: 76px; */
	height: 33px;
	font-size: 24px;
	font-family: PingFangSC-Thin, PingFang SC;
	font-weight: 100;
	color: #444444;
	line-height: 33px;
}

.VIshow .Folder .CN {
	margin-top: 206px;
	margin-left: 1px;
	/* width: 102px; */
	height: 48px;
	font-size: 34px;
	font-family: PingFangSC-Light, PingFang SC;
	font-weight: 300;
	color: #444444;
	line-height: 48px;
}

.VIshow .Folder .EN {
	margin-left: 1px;
	/* width: 77px; */
	height: 33px;
	font-size: 24px;
	font-family: PingFangSC-Thin, PingFang SC;
	font-weight: 100;
	color: #444444;
	line-height: 33px;
}

/* 关于VI系统 */
.VISystem {
	margin-top: 184px;

}

.VISystem .content {
	display: flex;
}

.VISystem .content .detail .CN {
	margin-left: 50px;
	height: 87px;
	font-size: 21px;
	font-family: PingFangSC-Thin, PingFang SC;
	font-weight: 100;
	color: #444444;
	line-height: 29px;
}

.VISystem .content .detail .EN {
	margin-top: 45px;
	margin-left: 50px;
	height: 140px;
	font-size: 20px;
	font-family: PingFangSC-Thin, PingFang SC;
	font-weight: 100;
	color: #444444;
	line-height: 28px;
}

.VISystem .content .center {

	margin-left: 445px;
	writing-mode: vertical-lr;
}

.VISystem .content .center .cleft {
	width: 40px;
	height: 250px;
	font-size: 34px;
	font-family: PingFangSC-Light, PingFang SC;
	font-weight: 300;
	color: #444444;
	line-height: 50px;
	letter-spacing: 8px;
}

.VISystem .content .center .cright {
	margin-left: 14px;
	/* width: 37px; */
	height: 150px;
	font-size: 24px;
	font-family: PingFangSC-Thin, PingFang SC;
	font-weight: 100;
	color: #444444;
	line-height: 30px;
	letter-spacing: 2px;
}

.VISystem .content .right {

	margin-left: 114px;
	/* width: 69px; */
	height: 2px;
	font-size: 18px;
	font-family: PingFangSC-Thin, PingFang SC;
	font-weight: 100;
	color: #444444;
	line-height: 25px;
}

/* 关于空间 */
.aboutSI {
	width: 1300px;
	margin: 0 auto;
}

.aboutSI .top {
	display: flex;
}

.aboutSI .top .left {
	margin-top: 78px;
	margin-left: 15px;
	width: 138px;
	height: 45px;
	font-size: 32px;
	font-family: PingFangSC-Light, PingFang SC;
	font-weight: 300;
	color: #A48D29;
	line-height: 45px;
	letter-spacing: 1px;
}

.aboutSI .top .right {
	margin-top: 94px;
	margin-left: 13px;
	/* width: 98px; */
	height: 25px;
	font-size: 18px;
	font-family: PingFangSC-Thin, PingFang SC;
	font-weight: 100;
	color: #A48D29;
	line-height: 25px;
	letter-spacing: 1px;
}

.aboutSI .center {
	margin-top: 27px;
	margin-left: 15px;
	width: 1252px;
	height: 105px;
	font-size: 21px;
	font-family: PingFangSC-Thin, PingFang SC;
	font-weight: 100;
	color: #A48D29;
	line-height: 29px;
}

.aboutSI .bottom {
	margin-top: 30px;
	margin-left: 15px;
	width: 1261px;
	height: 100px;
	font-size: 18px;
	font-family: PingFangSC-Thin, PingFang SC;
	font-weight: 100;
	color: #A48D29;
	line-height: 25px;
	letter-spacing: 1px;
	word-break: break-all;
}

.bottomImg {
	width: 1920px;
	margin: 0 auto;
	margin-top: 184px;
}


/* 系列推荐 */
.recommend {
	margin-top: 109px;
	height: 685px;
	/* background-color: #A48D29; */
}



.recommend .title-wrap {
	text-align: center;
	/* color: #A48D29; */
	margin-bottom: 20px;
}



.recommend .title-wrap .name {
	height: 33px;
	font-size: 24px;
	font-family: PingFangSC-Light, PingFang SC;
	font-weight: 300;
	color: #A48D29;
	line-height: 33px;
}


.recommend .title-wrap .en {
	font-family: PingFangSC-Thin, PingFang SC;
	font-size: 16px;
	margin-top: 3px;
	height: 22px;
	line-height: 22px;
	letter-spacing: 2px;
	color: #A48D29;
}


.recommend .title-wrap .line {
	width: 34px;
	height: 1px;
	background-color: #A48D29;
	margin: auto;
	margin-top: 10px;
}


.recommend .content {
	position: relative;
}

.recommend .content .prev {
	position: absolute;
	left: 66px;
	top: 30%;
	z-index: 999;
	cursor: pointer;

}

.recommend .content .prev img {
	width: 40px;
	height: 40px;
}

.recommend .content .next {
	width: 40px;
	height: 40px;
	position: absolute;
	right: 66px;
	top: 30%;
	z-index: 999;
	cursor: pointer;
}

.recommend .content .next img {
	width: 40px;
	height: 40px;
}

.recommend .content .box {
	padding: 0 125px;
	display: flex;
	justify-content: space-between;
}

.recommend .content .cover {
	margin-top: 20px;
	width: 518px;
	height: 332px;
	overflow: hidden;
}

.recommend .content .cover img {
	width: 100%;
	height: 100%;
	object-fit: cover;
	transition: 0.2s;
	cursor: pointer;
}

.recommend .content .cover img:hover {
	transform: scale(1.1);
}

.recommend .content .box .name {
	height: 29px;
	font-size: 21px;
	margin-top: 10px;
	text-align: center;
	font-family: PingFangSC-Light, PingFang SC;
	font-weight: 300;
	color: #595857;
	line-height: 29px;
}

.recommend .content .box .more {
	margin-top: 17px;
}

.recommend .content .box .more span {
	width: 105px;
	height: 27px;
	font-size: 15px;
	font-family: PingFangSC-Thin, PingFang SC;
	line-height: 27px;
	padding: 3px 21px 2px 21px;
	border: 1px solid #c1c1c1;
	cursor: pointer;
	margin: 0px 208px;
}


.con {
	width: 1300px;
	margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/yiDesign.vue